if ($('.adPubliTop').length) {
    var swiper__adPubliTop = new Swiper('.swiper__adPubliTop', {
        speed: 400,
        spaceBetween: 100,
        pagination: {
            el: '.adPubliTop .swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
    });
}

$(document).ready(function () {
    $('.promocoes').slick({
        loop: true,
        autoplay: {
            delay: 2500,
        }
    });
});

var swiperConvenios = new Swiper(".swiper__convenios", {
    slidesPerView: 5,
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
    autoplay: {
        delay: 2500,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        // when window width is >= 320px
        450: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 4,
        },
    },

});